<template>
    <ui-input-base-textarea
        v-bind:is-invalid="isInvalid"
        v-bind="model"
        v-on:input="inputHandler"
        v-on:focus="focusHandler"
        v-on:blur="blurHandler"
    />
</template>

<script>
export default {
    name: 'ui-input-textarea',
    props: {
        model: {
            type: Object,
        },
        isInvalid: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [ String, Number ],
        },
    },
    model: {
        prop: 'value',
        event: 'input',
    },
    methods: {
        inputHandler(newValue) {
            this.$emit('input', newValue);
        },
        focusHandler(data) {
            this.$emit('focus', data);
        },
        blurHandler(data) {
            this.$emit('blur', data);
        },
    },
};
</script>

<style scoped lang="less">
@import "~theme";

.ui-input-textarea {
    width: 100%;
}
</style>
